/**
 * @file 标记类型
 * @author
 */

import mark1 from './imgs/1-normal.png';
import mark1Click from './imgs/1-click.png';
import mark2 from './imgs/2-normal.png';
import mark2Click from './imgs/2-click.png';
import mark3 from './imgs/3-normal.png';
import mark3Click from './imgs/3-click.png';
import mark4 from './imgs/4-normal.png';
import mark4Click from './imgs/4-click.png';
import mark5 from './imgs/5-normal.png';
import mark5Click from './imgs/5-click.png';
import mark6 from './imgs/6-normal.png';
import mark6Click from './imgs/6-click.png';
import mark7 from './imgs/7-normal.png';
import mark7Click from './imgs/7-click.png';
import mark8 from './imgs/8-normal.png';
import mark8Click from './imgs/8-click.png';
import mark9 from './imgs/9-normal.png';
import mark9Click from './imgs/9-click.png';
import mark10 from './imgs/10-normal.png';
import mark10Click from './imgs/10-click.png';
import mark11 from './imgs/11-normal.png';
import mark11Click from './imgs/11-click.png';
import mark12 from './imgs/12-normal.png';
import mark12Click from './imgs/12-click.png';
export const markTypeObj = [{
    id: '1',
    title: '诈骗电话',
    normal: mark1,
    click: mark1Click,
    type: 1,
}, {
    id: '11',
    title: '违法电话',
    normal: mark2,
    click: mark2Click,
    type: 1,
}, {
    id: '10',
    title: '骚扰电话',
    normal: mark3,
    click: mark3Click,
    type: 1,
}, {
    id: '13',
    title: '客服热线',
    normal: mark4,
    click: mark4Click,
    type: 2,
}, {
    id: '4',
    title: '中介公司',
    normal: mark5,
    click: mark5Click,
    type: 2,
}, {
    id: '7',
    title: '送餐外卖',
    normal: mark6,
    click: mark6Click,
    type: 2,
}, {
    id: '8',
    title: '快递物流',
    normal: mark7,
    click: mark7Click,
    type: 2,
}, {
    id: '3',
    title: '金融理财',
    normal: mark8,
    click: mark8Click,
    type: 2,
}, {
    id: '5',
    title: '猎头招聘',
    normal: mark9,
    click: mark9Click,
    type: 2,
}, {
    id: '12',
    title: '网约车',
    normal: mark10,
    click: mark10Click,
    type: 2,
}, {
    id: '2',
    title: '保险公司',
    normal: mark11,
    click: mark11Click,
    type: 2,
}, {
    id: '6',
    title: '广告营销',
    normal: mark12,
    click: mark12Click,
    type: 2,
}];

export const CONTACT_TIME_TYPE = [
    {phone: '未产生通话'},
    {phone: '3分钟以下'},
    {phone: '3到5分钟'},
    {phone: '5到10分钟'},
    {phone: '10分钟以上'},
];

export const HARASS_TYPE = [{
    label: '自动语音',
    value: '1'
}, {
    label: '人工',
    value: '2'
}];
